'use client'

import { useExtracted } from 'next-intl'

interface VideoCreditBadgeProps {
  video: {
    creditLabel: string
    creditTitle: string
    creditUrl: string
  }
}

export function VideoCreditBadge({ video }: VideoCreditBadgeProps) {
  const t = useExtracted()
  const creditLabels: Record<string, string> = {
    "Gami Orbegoso's film": t("Gami Orbegoso's film"),
  }

  return (
    <a
      href={video.creditUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/50 px-4 py-2.5 backdrop-blur-xl transition-all duration-300 hover:scale-105 hover:border-white/30 hover:bg-black/70"
    >
      <span className="text-xs font-light text-white/70 md:text-sm">
        {creditLabels[video.creditLabel] ?? video.creditLabel}
      </span>
      <span className="text-xs font-medium text-white transition-colors group-hover:text-white md:text-sm">
        {video.creditTitle}
      </span>
    </a>
  )
}
